import script from "./ColorCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./ColorCheckbox.vue?vue&type=style&index=0&id=4a1418a4&lang=css"

const __exports__ = script;

export default __exports__